function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import LogoBoxAtm from "../../atoms/LogoBoxAtm";
import BreadcrumbsMol from "../../molecules/BreadcrumbsMol";
import BreakpointVisibilityOrg from "../BreakpointVisibilityOrg";
var Container = styled.div.withConfig({
  componentId: "sc-17vqpkp-0"
})(function (_ref) {
  var $backgroundImage = _ref.$backgroundImage;
  return css(["&::before{content:\"\";display:block;position:absolute;top:0;right:0;left:0;height:", ";background:url(", ") no-repeat center / cover;}> *{z-index:1;}", "{&::before{height:", ";background-image:url(", ");}}", "{&::before{background-image:url(", ");}}"], space(15), $backgroundImage.small, breakpoint("medium"), space(21), $backgroundImage.medium, breakpoint("large"), $backgroundImage.large);
});
var Wrapper = styled.div.withConfig({
  componentId: "sc-17vqpkp-1"
})(["display:flex;justify-content:space-between;align-items:flex-start;position:relative;margin-bottom:", ";", "{margin-bottom:", ";}"], space(3), breakpoint("medium"), space(4));
var BadgeWrapper = styled.div.withConfig({
  componentId: "sc-17vqpkp-2"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["padding:", ";box-shadow:", ";background-color:", ";border-radius:", ";"], space(2), getBoxShadow(theme, "medium"), getColor(theme, "white"), space(1));
});
function ProductHeaderOrg(_ref3) {
  var backgroundImage = _ref3.backgroundImage,
    logo = _ref3.logo,
    breadcrumbs = _ref3.breadcrumbs,
    logoZoomLightBox = _ref3.logoZoomLightBox,
    badge = _ref3.badge;
  var hasLightBox = !!logoZoomLightBox;
  var commonProps = _objectSpread(_objectSpread({}, logo), {}, {
    hasLightbox: hasLightBox,
    openLightBoxText: hasLightBox && logoZoomLightBox ? logoZoomLightBox.openText : undefined,
    closeLightBoxText: hasLightBox && logoZoomLightBox ? logoZoomLightBox.closeText : undefined
  });
  return /*#__PURE__*/React.createElement(Container, {
    $backgroundImage: backgroundImage
  }, /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: "medium"
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(LogoBoxAtm, _extends({}, commonProps, {
    size: hasLightBox ? "huge" : "medium"
  })))), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "medium"
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(LogoBoxAtm, _extends({}, commonProps, {
    size: hasLightBox ? "huge" : "large"
  })), badge ? /*#__PURE__*/React.createElement(BadgeWrapper, null, badge) : null)), /*#__PURE__*/React.createElement(BreadcrumbsMol, {
    items: breadcrumbs.items,
    currentItem: breadcrumbs.currentItem
  }));
}
export default ProductHeaderOrg;